// extracted by mini-css-extract-plugin
export default {"Box":"filter-input-container-module__Box--UTJd2","is-focused":"filter-input-container-module__is-focused--zg4vF"};